import React from 'react'

function Footer() {
    return (
        <div className='footer-container'>
            <p>created by <a href="https://nikola93kg.github.io/" target='_blank' rel="noopener noreferrer">nikola93kg</a> </p>
        </div>
    )
}

export default Footer